import {DataTableColumn} from "mantine-datatable";
import {Product} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {NavLink} from "react-router-dom";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {StatusBadge} from "../profile/StatusBadge.tsx";

// Every column is sortable (§3a). The `accessor` is what sorts: `created` sorts as
// ISO-8601, `status` on the enum's text. Status renders through the module's one
// StatusBadge, the same colours as the detail page (§13).
export const useProductsTableColumns = () => {

    const columns: DataTableColumn<Product>[] = [
        {
            accessor: 'name',
            title: I18n.get('Name'),
            width: '1fr',
            sortable: true,
            render: (item: Product) => <NavLink to={`/products/${item.id}`}>{item.name}</NavLink>,
        },
        {
            accessor: 'status',
            title: I18n.get('Status'),
            sortable: true,
            render: (item: Product) => <StatusBadge status={item.status}/>,
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            width: '1fr',
            sortable: true,
            render: (item: Product) => formatTimestamp(item.created),
        },
    ];

    return {
        columns,
    }
}
